export const dateFormatter = (date: string, type?: 'date' | 'time') => {
  const cDate = new Date(date);
  const yy = cDate.getFullYear().toString();
  let mm = cDate.getMonth() + 1;
  let dd = cDate.getDate();
  let hours = cDate.getHours();
  let minutes = cDate.getMinutes();

  const formattedDate = `${yy}/${mm < 10 ? `0${mm}` : mm}/${dd < 10 ? `0${dd}` : dd}`;
  const formattedTime = `${hours < 10 ? `0${hours}` : hours}:${
    minutes < 10 ? `0${minutes}` : minutes
  }`;

  if (type === 'date') {
    return formattedDate;
  } else if (type === 'time') {
    return formattedTime;
  } else {
    return `${formattedDate} ${formattedTime}`;
  }
};
